import { generateClient } from 'aws-amplify/api';
import { newDailyReport } from '../graphql/customQueries';

const client = generateClient();

export default async ({
    id,
    customerId,
    locationId,
    foremanId,
    foremanName,
    submissionDate,
    media,
    summary,
    isCompleted,
    qaqcCompleted,
    anyoneInjured,
    siteSecured,
    customerName,
    type,
    address,
    inspectionType,
    inspectionQuestion,
    taskArea,
    weather,
    correctiveActions,
    foremanSignature,
    safetySignature
}) => {
    const {
        data: { newDailyReport: createdDailyReport },
    } = await client.graphql({
        query: newDailyReport,
        variables: {
            input: {
                id,
                customerId,
                locationId,
                foremanId,
                submissionDate,
                summary,
                isCompleted,
                qaqcCompleted,
                anyoneInjured,
                siteSecured,
                customerName,
                type,
                address,

                inspectionType,
                foremanName,
                taskArea,
                weather,
                inspectionQuestion,
                foremanSignature,
                safetySignature,
                correctiveActions,

                media: {
                    items: media.items?.map(m => ({
                        id: m.id,
                        filename: m.filename,
                        description: m.description,
                        mediaType: m.mediaType,
                        sortKey: m.sortKey,
                    }))
                }
            },
        },
    });
    return createdDailyReport;
};




